import { API_BASE_URL } from '../common/ApiClient';
import { ProcessingEventUrl } from '../processingEvent/query/ProcessingEventUrl';

export type * from './schema/types';
export * from './schema/InputDataSchema';
export * from './schema/SampleCommentSchema';
export * from './schema/DataObjectGroupProcessingStateSchema';
export * from './query/useInputDataActionMutation';
export * from './query/useInputDataAccessRightsQuery';
export * from './query/useInputDataGroupProcessingStateQuery';
export * from './query/useInputDataGroupProcessingStateRefreshQuery';
export * from './query/useInputDataActiveQuery';
export * from './query/useDescriptionOutputSnapshotQuery';
export * from './query/useDescriptionOutputSnapshotVersionQuery';
export * from './query/useInputDataDetailsActionMutation';
export * from './query/useInputDataDeleteMutation';
export * from './query/useInputDataDetailsPreviewMutation';
export * from './query/useInputDataDetailsCommentMutation';
export * from './query/useInputDataDetailsCommentsMutation';
export * from './query/useInputDataDetailsQuery';
export * from './query/useInputDataOutputsQuery';
export * from './edit-session/query/useMutateSubjectInputDataUpload';
export * from './query/useMutateInputDataUploadAction';
export * from './query/useMutateInputDataUpload';
export * from './query/useInputDataProcessingEventsQuery';
export * from './query/useOutputValueDateQuery';
export * from './query/useOutputVersionQuery';
export * from './query/useMutateInputDataLock';
export * from './edit-session';
export { InputDataScopeKey } from './InputDataKey';

export const InputProcessingErrorExcelUrl =
  API_BASE_URL + ProcessingEventUrl.INPUT_PROCESSING_EVENT_ERROR_EXCEL;

export const InputDataSubjectDetailsUrl =
  '/data/input-data/details{?descriptionId,groupId,date,subject}';
